export const enum AuthActionTypes {
    SET_TOKEN = 'SET_TOKEN',
    INITIATE_LOGOUT = 'INITIATE_LOGOUT',
}
